import { LocalStorageService } from './../../core/services/local-storage.service';
import { environment } from './../../../environment/environment';
import { CallOfferService } from './../../core/services/call-offer-service/call-offer.service';
import { Component, ElementRef, TemplateRef } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { ISort } from './../../core/models/candidat';
import { headerColumns8 } from './../../core/models/consulatntexterne';
import {
  EmptyCV,
  addedExternalConsult,
  associatedConsult,
  associatedautreConsult,
  fileTypeExtention,
  inexistedConsultantEsn,
  obligationSelect,
  serverError,
} from './../../core/models/messages';
import { linkedInRegExp, patternEmail } from './../../core/models/pattern';
import { CompanyService } from './../../core/services/company/company.service';
import { EsnCandidatService } from './../../core/services/esn-candidat/esn-candidat.service';
import { EsnConsultantService } from './../../core/services/esn-consultant/esn-consultant.service';
import { SalarieService } from './../../core/services/salarie-service/salarie.service';
import { SortDataService } from './../../core/services/sortdata';
import { Country, State } from 'country-state-city';
import * as saveAs from 'file-saver';
import * as JSZip from 'jszip';
import * as moment from 'moment';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { distinctUntilChanged, Subject, takeUntil } from 'rxjs';
import Swal from 'sweetalert2';
import { translations } from '../../core/models/call-offer';
@Component({
  selector: 'app-consultant-enattente',
  templateUrl: './consultant-enattente.component.html',
  styleUrls: ['./consultant-enattente.component.css']
})
export class ConsultantEnattenteComponent {
  fileName: string = '';
  fileError: string = '';
  fileExtention: string = '';
  stateList: any = [];
  selectedconsultant: any;
  mobilities: any[] = [];
  isCollapsed = true;
  toggleCollapsible() {
    this.isCollapsed = !this.isCollapsed;
  }
  id: any;
  showResetButtons: boolean = true;
  searchForm: FormGroup = this.createSearchForm();
  loadSpinnerTable: boolean = false;
  pagination : boolean =false;

  itemsPerPage: number = 5;
  currentPage: number = 1;
  currentSortDirection: number = 1;
  startIndex: number = 0;
  endIndex: number = 5;
  totalItems!: number;
  listskills: any;
  listconsulant: any;
  isLoadSpinner: boolean = true;

  /* get all companies */
  idclientConnected: any;
  selectedFile: File | null = null;
  listconsulatant: any = [];
  skillsList: { name_FR: string }[] = [];
  isexistemail = false;
  urlimage: string = environment.baseUrlGalery;
  urlcv: string = environment.baseUrlGaleryCv;
  url: string = environment.baseUrl + '/api';
  selectedCandidats: any = [];
  idClientFinal!: string | null;
  esnList: { id: number; name: string }[] = [];
  listConsultant: any = [];
  countries: any = [];
  skillsListData: any = [];
  listEmail: any = [];
  skills: any[] = [];
  fileExtentions: string = '';
  listProjects: { id: number; name: string }[] = [];
  currentDate: string;
  today=new Date();
  /* modal */
  modalRef?: BsModalRef;
  addBulk!: FormGroup;
  /* formGroup */
  ConsultForm: FormGroup = this.createForm();
  UpdateForm: FormGroup = this.updateForm();
  paysList: any[] = Country.getAllCountries().map((country) => ({
    ...country,
    name: this.translateCountryName(country.name),
  }));

  file: any = '';
  /* generate email control */
  esn_name = new FormControl();
  ischecked = true;
  loadSpinner: boolean = false;
  sortAttr: string = '';
  fileBulkError: any;
  listNames: string[] = [];
  dataHeader: any = [];

  /* unsubscription */
  private unsubscribeAll: Subject<void> = new Subject();
  headerColumns: { checked: boolean; name: string; code: string }[] =
    headerColumns8;
  data: any[] = [
    {
      competences: [
        'nom',
        'prenom',
        'num',
        'email',
        'poste',
        'fournisseur',
        'site_web_fournisseur',
        'linkedin_fournisseur',
        'date_debut_mission',
        'date_fin_mission',
        'tjm_achat',
        'linkedin',
        'cv',
        'id_projet',
      ],
    },
  ];
  fileErr: boolean = false;
  constructor(
    private companyService: CompanyService,
    private candidatservice: EsnCandidatService,
    private sortDataService: SortDataService,
    private salarieservice: SalarieService,
    private formBuilder: FormBuilder,
    private modalService: BsModalService,
    private spinner: NgxSpinnerService,
    private toastrService: ToastrService,
    private esnconsultantservice: EsnConsultantService,
    private callofferService: CallOfferService,
    private localStorageService: LocalStorageService,
    private elRef: ElementRef,
  ) {
    const day = String(this.today.getDate()).padStart(2, '0');
    const month = String(this.today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = this.today.getFullYear();
    this.currentDate = `${year}-${month}-${day}`;
   
  }
  ngOnInit() {
    const scrollableTable = this.elRef.nativeElement.querySelector('#kt_customers_table');
    scrollableTable?.addEventListener('scroll', this.closeDropdownOnScroll.bind(this));
    this.idClientFinal = this.localStorageService.getData('clientConnected');
    this.countries = Country.getAllCountries();

    this.getSkills();
    this.getListskills();
    this.getListprojet();
    this.getListconsultant();
    this.getEsnList();
    this.getListElementHeader();
    this.ConsultForm.enable();
    this.ConsultForm.get('linkedin_link')?.valueChanges
    .pipe(distinctUntilChanged())
    .subscribe(() => {
      this.setValidatorRequirements();
    });

  this.ConsultForm.get('cv')?.valueChanges
    .pipe(distinctUntilChanged())
    .subscribe(() => {
      this.setValidatorRequirements();
    });

  // Appelez la méthode une fois pour initialiser les validateurs
  this.setValidatorRequirements();
  }

  closeDropdownOnScroll(): void {
    // Find the open dropdown
    const dropdown = this.elRef.nativeElement.querySelector('.dropdown-menu.show');
    
    // If the dropdown is open, remove the 'show' class to close it without triggering a page scroll
    if (dropdown) {
      dropdown.classList.remove('show');
      console.log('HEYYYYYYYYYYYY');
    }
  }
  openModalBulk(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });
    this.ConsultForm.get('open_for_mission')?.setValue(1);
    this.fileExtentions = '';
  }
  /* download file add bulk */
  downloadCsv() {
    this.companyService.downloadcsvfileAddBulkconsultantexterne().subscribe({
      next: (res: Blob) => {
        console.log("res", res);
        const blob = new Blob([res], { type: 'text/csv;charset=utf-8;' });
        saveAs(blob, 'ajout en masse client consultant externe.csv');
      },
      error: (err) => {
        console.log('error', err);
        // Handle the error appropriately
      },
    });
  }
  formAddBulk() {
    this.addBulk = this.formBuilder.group({
      file: [null, [Validators.required]],
    });
  }

  /*select file and add Bulk Candidates */
  onFileSelected(event: any) {
    this.fileErr = false;
    this.fileExtentions = '';
    this.selectedFile = event.target.files[0];

    if (this.selectedFile) {
      console.log('Fichier sélectionné :', this.selectedFile);
      const fileExtension = this.selectedFile.name
        .toLowerCase()
        .substr(this.selectedFile.name.lastIndexOf('.'));
      const allowedExtensions = ['.csv', '.xlsx', '.xls'];
      if (!allowedExtensions.includes(fileExtension)) {
        console.log('selectedFile', fileExtension);
        this.fileExtentions = fileTypeExtention;
        this.fileErr = true;
      }
    }
  }

  addBulkCandidates() {
    if (this.selectedFile) {
      const formData = new FormData();
      formData.append('file', this.selectedFile);
      formData.append('client_id', this.idclientConnected);
      this.spinner.show();
      this.companyService.addBulkCandidates(formData).subscribe({
        next: (res: any) => {
          this.spinner.hide();

          this.fileBulkError = res.export_file;
          console.log('file bluk error', this.fileBulkError);
          this.getbulkCandidate(this.fileBulkError);
          this.toastrService.success('Fichier importé avec succès');
          this.closeModal();
          this.selectedFile = null;
        },
        error: (err) => {
          this.spinner.hide();
          if (err?.error) {
            if (err.error?.message) {
              if (err.error.message === 'File contains only headers.') {
                this.toastrService.error('Le fichier est vide');
              } else if (
                err.error.message ===
                'File headers do not match the expected headers.'
              ) {
                this.toastrService.error(
                  'Les en-têtes de fichiers ne correspondent pas aux en-têtes attendus.'
                );
              } else {
                this.toastrService.error(serverError);
              }
            } else {
              this.toastrService.error(serverError);
            }
            this.closeModal();
            this.selectedFile = null;
          }
        },
      });
    }
  }
  getbulkCandidate(file: File) {
    let exportSuccess = false;
    this.companyService.getbulkCandidate(file).subscribe({
      next: (res: any) => {
        this.spinner.hide();
        const blob = new Blob([res], { type: 'application/octet-stream' });
        saveAs(blob, this.fileBulkError);
        exportSuccess = true;
        if (exportSuccess) {
          this.toastrService.success(
            'Résultat de fichier importé a été exporté avec succès'
          );
        }
      },
      error: () => {
        this.spinner.hide();
        this.toastrService.error(serverError);
      },
    });
  }

  /*page consultant externel */
  getListElementHeader() {
    // if(!this.typeintervenant){
    this.companyService
      .getHeaderElementsconsultantcf(21)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.dataHeader = res.data;
          for (const iterator of this.dataHeader) {
            if (
              (iterator.checked == 'oui' && !iterator.checked_user) ||
              (iterator.checked == 'non' && iterator.checked_user == 'oui') ||
              (iterator.checked == 'oui' && iterator.checked_user == 'oui')
            )
              this.listNames.push(iterator.name);
          }
          this.dataHeader.map((el: any) => {
            if (
              (el.checked == 'oui' && !el.checked_user) ||
              (el.checked_user == 'oui' &&
                (el.checked == 'non' || el.checked == 'oui'))
            ) {
              return (el.checkAdmin = true);
            } else {
              return (el.checkAdmin = false);
            }
          });
        },
        error: () => {},
      });
  }

  changeSelectionElement(event: any, data: any, i: number) {
    this.listNames = [];
    data.checkAdmin = event.target.checked;
    for (const iterator of this.dataHeader) {
      if (iterator.checkAdmin) this.listNames.push(iterator.name);
    }
    this.changeSelectionHeadrElements(data);
  }
  changeSelectionHeadrElements(data: any) {
    // if(!this.typeintervenant){
    let payload = {
      sub_page_id: data?.id,
    };
    this.companyService
      .changeDelectedElementHeaderconsultantcf(payload)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {},
        error: () => {},
      });
    // }
    // else{
    //   let payload={
    //     sub_page_id:data?.id
    //   }
    //   this.esnconsultantservice.changeSubPageStateconsultantIntervenant(payload).pipe(takeUntil(this.unsubscribeAll)).subscribe({
    //     next: (res) => {

    //     },
    //     error: () => {

    //     }
    //   })
    // }
  }
  /**/
  getEsnList() {
    this.spinner.show();
    this.companyService
      .getListEsnClient(this.idClientFinal)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          // this.isLoadSpinner = false;
          this.spinner.hide();
          console.log('resssssssssesn', res);
          console.log('resssssssssesn', res.data);
          this.esnList = res.data;
          console.log('resssssssssesn', this.esnList);
          // for (const iterator of res.data) {
          //   this.esnList.push({ id: iterator.e_s_n.id, name: iterator.e_s_n.name })
          // }
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }
  translateCountryName(name: string): string {
   
    return translations[name] || name;
  }
  getConsultant() {
    this.companyService
      .getExternalConsultant()
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.ConsultForm = this.createForm(res.data);
        },
        error: () => {},
      });
  }
  resetCV() {
    const inputFile = document.getElementById('cv') as HTMLInputElement;
    if (inputFile) {
      inputFile.value = '';
      this.fileExtention = '';
      this.fileError = '';
    }
    this.fileName = '';
    this.showResetButtons = true;
  }
  uploadFile(event: any) {
    this.file = event.target.files[0];
    const maxSize = 2 * 1024 * 1024;
    this.fileName = this.file.name;
    if (this.file) {
      const allowedExtensions = ['.pdf', '.docx', '.doc'];
      const fileExtension = this.file.name
        .toLowerCase()
        .substr(this.file.name.lastIndexOf('.'));

      if (!allowedExtensions.includes(fileExtension)) {
        this.fileExtention = 'Format fichier non compatible !';
      } else if (this.file.size > maxSize) {
        this.fileError = 'Le fichier à importer ne doit pas depasser 2 méga !';
      } else {
        this.fileError = '';
        this.fileExtention = '';
      }
      console.log('file', this.file);
    }
    this.ConsultForm.get('cv')?.setValue(this.file);
  }

  validateDateRange(formGroup: FormGroup): { [key: string]: any } | null {
    const startDate = formGroup.get('date_first_mission')?.value;
    const endDate = formGroup.get('date_end_mission')?.value;

    if (startDate && endDate && startDate > endDate) {
      return {
        dateRangeError:
          'La date de début de mission doit être antérieure à la date de fin de mission.',
      };
    }

    return null;
  }

  
  changeCompany() {
    // this.ConsultForm.disable()
    this.getuserbyEsn();
  }
  getListskills() {
    this.salarieservice.getSkills().subscribe({
      next: (response) => {
        console.log('list skills', response);
        if (response.data) {
          this.skillsList = response.data;
          this.listskills = response.data;
          this.skills = response.data;
          console.log('list skills', this.listskills);
        }
      },
      error: (error) => {
        console.error('Error fetching skills: ', error);
      },
    });
  }
  downloadFile(type: string, candidat?: any, typeFile?: string) {
    if (this.ischecked) {
      if (type == 'single' && candidat) {
        if (candidat.cv || candidat.file_test) {
          if (typeFile && typeFile != '')
            candidat.file_test = candidat.file_test.split('/')[1];
          const fileUrl = !typeFile
            ? `${this.url}/User/file/gallery_cvs/${candidat.cv}`
            : `${this.url}/ResponseCandidate/GetFile/${candidat.file_test}`; // Replace with your file URL
          this.showGlobalSpinner();
          this.candidatservice.downloadPDF(fileUrl).subscribe(
            (data) => {
              const blob = new Blob([data], {
                type: 'application/octet-stream',
              });
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = !typeFile
                ? `${candidat.ID_user}_${candidat.first_name}_${
                    candidat.last_name
                  }_CV.${candidat!.cv.split('.').pop()}`
                : `${candidat.ID_user}_${candidat.first_name}_${
                    candidat.last_name
                  }_QCM.${candidat!.file_test.split('.').pop()}`;
              document.body.appendChild(a);
              a.click();
              window.URL.revokeObjectURL(url);
              this.hideGlobalSpinner();
            },
            () => {
              this.hideGlobalSpinner();
            }
          );
        } else {
          this.toastrService.info(EmptyCV);
        }
      } else if (this.selectedCandidats.length) {
        if (
          this.selectedCandidats.length == 1 &&
          !this.selectedCandidats[0].cv
        ) {
          this.toastrService.info(EmptyCV);
        } else this.downloadPdfFiles(typeFile);
      } else {
        this.toastrService.info(obligationSelect);
      }
    } else {
      this.toastrService.error(
        'Limite de téléchargements atteinte. Vous ne pouvez télécharger que 3 fichiers.'
      );
    }
  }
  hideGlobalSpinner() {
    this.loadSpinner = false;
    this.spinner.hide();
  }
  showGlobalSpinner() {
    this.loadSpinner = true;
    this.spinner.show();
  }
  downloadPdfFiles(typeFile?: string) {
    const zip = new JSZip();
    const fileUrls = this.selectedCandidats.map(
      (el: {
        cv: string;
        file_test: string;
        first_name: string;
        last_name: string;
        ID_user: string;
      }) => {
        if (!typeFile) {
          return {
            url: `${this.url}/User/file/gallery_cvs/${el.cv}`,
            first_name: el.first_name,
            last_name: el.last_name,
            ID_user: el.ID_user,
            cv: el.cv,
          };
        } else {
          // if(el.file_test!=null)
          return {
            url: `${this.url}/ResponseCandidate/GetFile/${
              el?.file_test?.split('/')[1]
            }`,
            first_name: el.first_name,
            last_name: el.last_name,
            ID_user: el.ID_user,
            response: el?.file_test?.split('/')[1],
          };
        }
      }
    );
    this.showGlobalSpinner();
    const downloadPromises = fileUrls.map((pdfUrl: any) => {
      return this.candidatservice
        .getPdfContent(pdfUrl.url)
        .toPromise()
        .then(
          (pdfContent: any) => {
            this.hideGlobalSpinner();
            zip.file(
              !typeFile
                ? `${pdfUrl.ID_user}_${pdfUrl.first_name}_${
                    pdfUrl.last_name
                  }_CV.${pdfUrl.cv.split('.').pop()}`
                : `${pdfUrl.ID_user}_${pdfUrl.first_name}_${
                    pdfUrl.last_name
                  }_QCM.${pdfUrl.response.split('.').pop()}`,
              pdfContent
            );
          },
          (err: any) => {
            this.hideGlobalSpinner();
          }
        );
    });

    Promise.all(downloadPromises).then(() => {
      zip.generateAsync({ type: 'blob' }).then((content) => {
        if (!typeFile) {
          saveAs(content, 'RH_Profiles_CVs.zip'); // Specify the zip file name here
        } else {
          saveAs(content, 'RH_Profiles_QCMs.zip');
        }
      });
    });
  }
  changeEmail(email: any) {
    let consultatnt = this.listConsultant.find((el: any) => {
      return el.first_name == email.first_name;
    });
    // this.skillsListData = consultatnt.skills?.split(',')
    this.ConsultForm = this.createForm(consultatnt);
    // this.ConsultForm.get('skills')?.setValue(this.skillsListData)
    if (
      this.ConsultForm.value.first_name == this.ConsultForm.value.first_name
    ) {
      this.ConsultForm.get('first_name')?.setValue(email.first_name);
    }
    // this.ConsultForm.disable();
    this.ConsultForm.get('email')?.enable();
    this.ConsultForm.get('number_days_of_service')?.enable();
    this.ConsultForm.get('date_first_service')?.enable();
    this.ConsultForm.get('project_ids')?.enable();
    this.ConsultForm.get('poste')?.enable();
    this.ConsultForm.get('tjm_achat')?.enable();
    this.ConsultForm.get('date_end_mission')?.enable();
    this.ConsultForm.get('date_first_mission')?.enable();
    this.ConsultForm.get('emailProClient')?.enable();
  }

  
  setValidatorRequirements() {
    console.log('Updating validator requirements...');
    
    const linkedinControl = this.ConsultForm.get('linkedin_link');
    const cvControl = this.ConsultForm.get('cv');
  
    // Effacer les validateurs existants
    linkedinControl?.clearValidators();
    cvControl?.clearValidators();
  
    if (!linkedinControl?.value && !cvControl?.value) {
      linkedinControl?.setValidators([
        Validators.required,
        Validators.pattern(linkedInRegExp),
      ]);
      cvControl?.setValidators(Validators.required);
    } else {
      if (linkedinControl?.value) {
        linkedinControl?.setValidators([Validators.pattern(linkedInRegExp)]);
      }
      if (cvControl?.value) {
        cvControl?.clearValidators();
      }
    }
  
    linkedinControl?.updateValueAndValidity({ emitEvent: false });
    cvControl?.updateValueAndValidity({ emitEvent: false });
  }
  
  
  
  listnvmembresWithDisplayName() {
    this.listEmail.map((el: any) => {
      el.name = `${el.first_name} ${el.last_name}`;
    });
  }
  getuserbyEsn() {
    this.companyService
      .getConsultantByEsnName(this.esn_name?.value)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          console.log('listeconsultantesn', res);
          this.listConsultant = res.data;
          console.log('listeconsultantesn', this.listConsultant);
          this.listEmail = res.data;

          console.log('liste email', this.listEmail);
          if (!res.data.length) this.toastrService.info(inexistedConsultantEsn);
          else {
            this.listEmail.map((el: any) => {
              el.name = `${el.first_name} ${el.last_name}`;
            });
          }
        },
        error: () => {},
      });
  }

  closeModal() {
    let btnClose = document.getElementById('ModalClose_add_salarie');
    this.ConsultForm.reset();
    this.esn_name.reset();
    this.fileName = '';
    this.modalRef!.hide();
    console.log('btnClose', btnClose);
    if (btnClose) {
      btnClose.click();
    }
  }
  reset() {
    this.stateList=[];
    this.searchForm.reset();
    this.searchForm = this.createSearchForm();
    this.searchconsultantexterne();
  }

  /* create search form */
  createForm(data?: any) {
    return this.formBuilder.group(
      {
        first_name: [data ? data?.first_name : '', [Validators.required]],
        last_name: [data ? data?.last_name : '', [Validators.required]],
        emailProClient: [
          data ? data?.emailProClient : '',
          [Validators.email, Validators.pattern(patternEmail)],
        ],
        id: [data ? data?.id : ''],
        email: [
          data ? data?.email : '',
          [
            Validators.required,
            Validators.email,
            Validators.pattern(patternEmail),
          ],
        ],
        linkedin_link: [data ? data?.linkedin_link : '',[Validators.pattern(linkedInRegExp)]],
        date_first_mission: [data ? data?.date_first_mission : ''],
        date_end_mission: [data ? data?.date_end_mission : ''],
        clientFinal_id: [data ? data?.clientFinal_id : ''],
        project_ids: [data ? data?.project_ids : []],
        date_first_service: [data ? data?.date_first_service : ''],
        number_days_of_service: [data ? data?.number_days_of_service : ''],
        poste: [data ? data?.poste : ''],
        esn_id: [data ? data?.esn_id : null],
        tjm_achat: [data ? data?.tjm_achat : ''],
        cv: [data ? data?.cv : ''],
        // consultant_client_final_id: [data ? data?.consultant_client_final_id : ''],
        // user_id:[data ? data?.user_id : ''],
      },
      { validator: this.validateDateRange }
    );
  }
  updateForm(data?: any) {
    return this.formBuilder.group(
      {
        first_name: [data ? data?.first_name : '', [Validators.required]],
        last_name: [data ? data?.last_name : '', [Validators.required]],
        emailProClient: [
          data ? data?.emailProClient : '',
          [Validators.email, Validators.pattern(patternEmail)],
        ],
        id: [data ? data?.id : ''],
        email: [
          data ? data?.email : '',
          [
            Validators.required,
            Validators.email,
            Validators.pattern(patternEmail),
          ],
        ],
        linkedin_link: [data ? data?.linkedin_link : ''],
        date_first_mission: [data ? data?.date_first_mission : ''],
        date_end_mission: [data ? data?.date_end_mission : ''],
        clientFinal_id: [data ? data?.clientFinal_id : ''],
        project_ids: [data ? data?.project_ids : []],
        date_first_service: [data ? data?.date_first_service : ''],
        number_days_of_service: [data ? data?.number_days_of_service : ''],
        poste: [data ? data?.poste : ''],
        esn_id: [data ? data?.esn_id : null],
        tjm_achat: [data ? data?.tjm_achat : ''],
        cv: [data ? data?.cv : ''],
        consultant_client_final_id: [
          data ? data?.consultant_client_final_id : '',
        ],
        user_id: [data ? data?.user_id : []],
      },
      { validator: this.validateDateRange }
    );
  }
  addExternalConsult() {
    this.setValidatorRequirements();
    if (this.ConsultForm.invalid) {
      this.ConsultForm.markAllAsTouched();
      this.ConsultForm.markAsDirty();
      return;
    }

    this.spinner.show();
    if (this.isexistemail) {
      let data = {
        esn_id: this.ConsultForm.value.esn_id,
        clientFinal_id: this.idClientFinal,
        consultant_id: this.id,
        project_ids: this.ConsultForm.value.project_ids,
        date_first_service: this.ConsultForm.value.date_first_service
          ? moment(this.ConsultForm.value.date_first_service).format(
              'YYYY-MM-DD'
            )
          : '',
        number_days_of_service: this.ConsultForm.value.number_days_of_service,
        emailProClient: this.ConsultForm.value.emailProClient,
        date_first_mission: this.ConsultForm.value.date_first_mission
          ? moment(this.ConsultForm.value.date_first_mission).format(
              'YYYY-MM-DD'
            )
          : '',
        date_end_mission: this.ConsultForm.value.date_end_mission
          ? moment(this.ConsultForm.value.date_end_mission).format('YYYY-MM-DD')
          : '',
        poste: this.ConsultForm.value.poste,
        tjm_achat: this.ConsultForm.value.tjm_achat,
      };
      this.companyService
        .addExternalConsultant(data)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: () => {
            this.spinner.hide();
            this.closeModal();
            this.ConsultForm.reset();
            this.esn_name.reset();
            this.toastrService.success(addedExternalConsult);
            this.getListconsultant();
            this.ConsultForm.enable();
          },
          error: (err) => {
            this.spinner.hide();
            if (err?.error) {
              console.log('erre', err.error?.message);
              if (
                err.error?.message &&
                err.error?.message == ' already associated to Client.'
              )
                this.toastrService.info(associatedConsult);
              if (
                err.error?.message &&
                err.error?.message ==
                  'consultant already associated to another Client.'
              )
                this.toastrService.info(associatedautreConsult);

              if (
                err.error?.message?.emailProClient &&
                err.error?.message?.emailProClient[0] ===
                  'The emailProClient has already been taken.'
              ) {
                this.toastrService.error(
                  "L'adresse e-mail professionel a déjà été utilisée."
                );
              }
              if (
                err.error?.message?.linkedin_link &&
                err.error?.message?.linkedin_link[0] ===
                  'The linkedin_link has already been taken.'
              ) {
                this.toastrService.error('linkedin link a déjà été utilisée.');
              }
            }
          },
        });
    } else {
      this.setValidatorRequirements();
      this.enableFormFields;
      this.ConsultForm.get('clientFinal_id')?.setValue(this.idClientFinal);
  
      let fromdata = new FormData();
      fromdata.append('clientFinal_id', this.ConsultForm.value.clientFinal_id);
      fromdata.append('first_name', this.ConsultForm.value.first_name);
      fromdata.append('last_name', this.ConsultForm.value.last_name);
      fromdata.append('email', this.ConsultForm.value.email);
      fromdata.append('emailProClient', this.ConsultForm.value.emailProClient);

 
      
      if (this.ConsultForm.value.linkedin_link === null) {
        fromdata.append('linkedin_link', '');
      }
      else{
        fromdata.append('linkedin_link', this.ConsultForm.value.linkedin_link);
      
      }
      if (this.ConsultForm.value.date_first_mission === null) {
        fromdata.append('date_first_mission', '');
      }
      else{
        fromdata.append(
          'date_first_mission',
          this.ConsultForm.value.date_first_mission
        );
      }
   
  
      if (this.ConsultForm.value.date_end_mission === null) {
        fromdata.append('date_end_mission', '');
      }
      else{
        fromdata.append(
          'date_end_mission',
          this.ConsultForm.value.date_end_mission
        );
      }
      if (this.ConsultForm.value.number_days_of_service === null) {
        fromdata.append('number_days_of_service', '');
      }
      else{
        fromdata.append(
          'number_days_of_service',
          this.ConsultForm.value.number_days_of_service
        );
      }
  
      if (this.ConsultForm.value.date_first_service === null) {
        fromdata.append('date_first_service', '');
      }
      else{
        fromdata.append(
          'date_first_service',
          this.ConsultForm.value.date_first_service
        );
      }
   
      fromdata.append('esn_id', this.ConsultForm.value.esn_id);
      if (this.ConsultForm.value.esn_id === null) {
        fromdata.delete('esn_id');
      }
    
      if (this.ConsultForm.value.emailProClient === null) {
        fromdata.delete('emailProClient');
      }

      if (this.ConsultForm.value.tjm_achat === null) {
        fromdata.append('tjm_achat', '');
      }
      else{
        fromdata.append('tjm_achat', this.ConsultForm.value.tjm_achat);
      }
      if (
        this.ConsultForm.value &&
        Array.isArray(this.ConsultForm.value.project_ids)
      ) {
        const project_ids = this.ConsultForm.value.project_ids;
        for (const projectId of project_ids) {
          fromdata.append('project_ids[]', projectId);
        }
      } else {
        console.error("project_ids n'est pas un tableau ou n'est pas défini.");
      }

     
      if (this.ConsultForm.value.poste === null) {
        fromdata.append('poste', '');
      }
      else{
        fromdata.append('poste', this.ConsultForm.value.poste);
      }
      if (this.file) {
        fromdata.append('cv', this.file);
      } else {
        fromdata.append('cv', '');
      }

      this.companyService
        .addExternalConsultant(fromdata)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: () => {
            this.spinner.hide();
            this.ConsultForm.reset();
            this.closeModal();
           
            this.esn_name.reset();
            this.toastrService.success(addedExternalConsult);
            this.getListconsultant();
            this.ConsultForm.enable();
          },
          error: (err) => {
            this.spinner.hide();
            if (err?.error) {
              if (
                err.error?.message &&
                err.error?.message == ' already associated to Client.'
              )
                this.toastrService.info(associatedConsult);
              if (
                err.error?.message &&
                err.error?.message ==
                  'consultant already associated to another Client.'
              )
                this.toastrService.info(associatedautreConsult);
              if (
                err.error?.message?.emailProClient &&
                err.error?.message?.emailProClient[0] ===
                  'The emailProClient has already been taken.'
              ) {
                this.toastrService.error(
                  "L'adresse e-mail professionel a déjà été utilisée."
                );
              }
              if (
                err.error?.message?.linkedin_link &&
                err.error?.message?.linkedin_link.includes('The linkedin link has already been taken.')
              ) {
                this.toastrService.error('linkedin link a déjà été utilisée.');
              }
              
              if (
                err.error?.message?.email &&
                err.error?.message?.email[0] ===
                  'The email has already been taken.'
              ) {
                this.toastrService.error(
                  "L'adresse e-mail  a déjà été utilisée."
                );
              }
            }
          },
        });
    }
  }
  /* key inter number */
  keyPress(event: any) {
    let pattern = /^[\d]$/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode !== 8 && pattern && !pattern.test(inputChar)) {
      event.preventDefault();
    }
    return pattern;
  }
  getSkillsArray(candidate: any): string[] {
    if (candidate && candidate.sub_categories_names) {
      return candidate.sub_categories_names
        .split(',')
        .map((s: string) => s.trim());
    } else {
      return [];
    }
  }
  /* get indexes for pagination */
  getItems(event?: any) {
    if (
      (event && event.startIndex != this.startIndex) ||
      this.endIndex != event.endIndex ||
      this.itemsPerPage != event.itemsPerPage ||
      this.currentPage != event.currentPage
    ) {
      this.startIndex = event.startIndex;
      this.endIndex = event.endIndex;
      (this.itemsPerPage = event.itemsPerPage),
        (this.currentPage = event.currentPage);
        if( (this.startIndex !=0 || this.endIndex !=5) || this.pagination == true){          this.pagination = true
          this.getListconsultant();}
    }
  }
  createSearchForm(data?: any) {
    return this.formBuilder.group({
      clientFinal_id: this.idClientFinal,
      name: ['', data?.name],
      esn_name: ['', data?.esn_name],
      poste: ['', data?.poste],
      skillsOr: [[], data?.skillsOr],
      skillsAnd: [[], data?.skillsAnd],
      project_id: [null, data?.project_id],
      max_experience_years: ['', data?.max_experience_years],
      min_experience_years: ['', data?.min_experience_years],
      tjm_achat: ['', data?.tjm_achat],
      mobility: [[], data?.mobility],
      pays: [[], data?.pays],
      search: [
        '',
        [Validators.pattern(/^("([^"]*"(AND|NOT|,|&&)[^"]*)*"|[^\s"']+)$/)],
      ],
      per_page: this.itemsPerPage,
      page: this.currentPage,
    });
  }
  /* search */
  searchconsultantexterne() {
    let valueForm = this.searchForm.value;
    let data = {
      clientFinal_id: this.idClientFinal,
      name: valueForm.name,
      poste: valueForm.poste,
      skillsOr: valueForm.skillsOr,
      skillsAnd: valueForm.skillsAnd,
      max_experience_years: valueForm.max_experience_years,
      min_experience_years: valueForm.min_experience_years,
      mobility: valueForm.mobility,
      pays: valueForm.pays,
      esn_name: valueForm.esn_name,
      tjm_achat: valueForm.tjm_achat,
      project_id: valueForm.project_id,

      per_page: this.itemsPerPage,
      page: this.currentPage,
      search: this.transformSearch(valueForm?.search),
    };
    console.log('data', data);
    this.spinner.show();
    this.companyService.searchConsultantattente(data).subscribe({
      next: (resSearch) => {
        if ( this.currentPage > 1) {
          this.currentPage = 1;
          this.searchconsultantexterne();
          this.spinner.hide();
          console.log('response search', resSearch);
        } else {
          this.listconsulatant = resSearch.data.data.slice(0, this.endIndex);
          this.totalItems = resSearch.data.total;
          this.spinner.hide();
        }
      },
      error: (error) => {
        console.log(error);
        this.toastrService.error(serverError);
        this.spinner.hide();
      },
    });
  }
  onCountryChange(mode: string): void {
    this.searchForm.get('mobility')?.enable();
    this.countries = this.searchForm.get('pays')?.value;
    this.countries = this.countries.map(
      (item: any) => this.paysList.filter((it) => it.name === item)[0]
    );

    console.log('item of countries ', this.countries);
    this.stateList.length = 0;
    // if (event.length) {
    this.countries.forEach((item: any) => {
      this.stateList.push(State.getStatesOfCountry(item.isoCode));
    });
    this.stateList = this.stateList.flat();
    for (const iterator of this.stateList) {
      iterator.name = iterator.name.replace(' Governorate', '');
    }
    this.stateList = this.stateList.map((item: any) => item.name);
    this.mobilities = this.searchForm.get('mobility')?.value;
    if (this.mobilities != null && this.mobilities.length > 0) {
      let differentItemsArray1: any[] = [];
      differentItemsArray1 = this.mobilities.filter(
        (item) => !this.stateList.includes(item)
      );
      const differentItemsArray2 = this.mobilities.filter(
        (item) => !differentItemsArray1.includes(item)
      );
      this.searchForm.get('mobility')?.setValue(differentItemsArray2);
    }
    // }
    if (this.stateList.length == 0) {
      this.stateList = [];
      mode == 'add';
      this.searchForm.get('mobility')?.setValue(null);
    }
  }
  onMobilityChange(mode: string) {
    this.mobilities = this.searchForm.get('mobility')?.value;
    let paysLists: any[] = [];
    this.countries = this.searchForm.get('pays')?.value;
    this.countries = this.countries.filter(async (item: any) => {
      paysLists.push(this.paysList.filter((it) => it.name === item)[0]);
    });
    let stateListAfter1: any[] = [];
    paysLists.forEach((item) => {
      let stateListAfter: any[] = [];
      stateListAfter = State.getStatesOfCountry(item.isoCode);
      let difference1: any[] = [];
      if (this.countries.length > 0) {
        difference1 = this.findDuplicates(
          this.mobilities,
          stateListAfter.map((item) => item.name)
        );
        console.log('difference1 : ', difference1.length);
        if (difference1.length == 0) {
          let index = this.countries.indexOf(item.name);
          if (index !== -1) {
            let new_array = this.countries
              .slice(0, index)
              .concat(this.countries.slice(index + 1));
            console.log('new_array is ', item.name);
            this.stateList = this.stateList.filter(
              (item: any) =>
                !stateListAfter.map((item) => item.name).includes(item)
            );

            // this.searchForm.get('pays')?.setValue(new_array);
          } else {
            console.log('String not found in array.', item.name);
          }
        }
      }
    });

    console.log('stateListAfter1 ', stateListAfter1);

    //  this.stateList=stateListAfter1

    this.mobilities = this.searchForm.get('mobility')?.value;
    if (this.mobilities.length === 0 || this.stateList.length === 0) {
      this.searchForm.get('mobility')?.disable();
      mode == 'add';
      this.searchForm.get('pays')?.setValue(null);
      mode == 'add';
      this.searchForm.get('mobility')?.setValue(null);
      this.searchForm.get('pays')!.updateValueAndValidity();
      this.searchForm.get('mobility')!.updateValueAndValidity();
      this.stateList.length = 0;
    } else {
      /*  if(this.countries) {
        this.countries.forEach((item) => {
          console.log('item of countries ', item);
  
        });
      }*/
    }
  }

  findDuplicates(array1: any, array2: any) {
    let occurrences: any[] = [];
    let duplicates: any = [];
    for (let element of array1) {
      occurrences[element] = (occurrences[element] || 0) + 1;
    }
    for (let element of array2) {
      if (occurrences[element] && !duplicates.includes(element)) {
        duplicates.push(element);
      }
    }

    return duplicates;
  }
  transformSearch(search: string): string {
    // Remplace toutes les occurrences de '||' par 'OR'
    search = search.replace(/\|\|/g, ' OR ');

    // Remplace toutes les occurrences de '&&' par ' AND '
    search = search.replace(/&&/g, ' AND ');

    // Remplace toutes les occurrences de '!' par ' NOT '
    search = search.replace(/!/g, ' NOT ');

    // Ajoute des espaces autour des opérations logiques pour éviter des conflits avec les mots
    search = search.replace(/\b(AND|OR|NOT)\b/g, ' $1 ');

    // Remplace les termes entre guillemets doubles par les mêmes termes sans modification
    // et échappe les guillemets simples à l'intérieur des termes non compris entre guillemets
    search = search.replace(/"([^"]+)"|(\S+)/g, (match, p1, p2) => {
      if (p1) {
        return `"${p1}"`;
      } else {
        // Si le terme n'est pas entre guillemets, échappe les guillemets simples à l'intérieur du terme
        const escapedTerm = p2.replace(/"/g, '\\"');
        return `${escapedTerm}`;
      }
    });

    // Supprime les espaces en double pour une meilleure lisibilité
    search = search.replace(/\s+/g, ' ');

    // Renvoie la chaîne de recherche transformée
    return search.trim();
  }

  isSimpleWord(value: string): boolean {
    const simpleWordPattern = /^[a-zA-Z0-9]+(\s[a-zA-Z0-9]+)?$/;
    return simpleWordPattern.test(value);
  }

  sortData(item: string) {
    console.log('item', item);
    for (const iterator of headerColumns8) {
      if (item == iterator.name) item = iterator.code;
    }
    this.sortAttr = item;
    this.currentSortDirection = this.currentSortDirection === 1 ? 2 : 1;
    this.currentPage = 1;
    if (this.searchForm.dirty)
      this.listconsulatant = this.sortDataService.sortArray(
        this.listconsulatant,
        item,
        this.currentSortDirection
      );
    else this.getListconsultant();
  }
  getListconsultant(sort?: ISort) {
    this.idclientConnected =
      this.localStorageService.getData('clientConnected');
    let dataPyload =
      this.sortAttr == ''
        ? {
            clientFinal_id: this.idclientConnected,
            per_page: this.itemsPerPage,
            page: this.currentPage,
          }
        : {
            ...{
              clientFinal_id: this.idclientConnected,
              per_page: this.itemsPerPage,
              page: this.currentPage,
            },
            ...{
              sort: this.currentSortDirection,
              sortAttribute: this.sortAttr,
            },
          };
    this.companyService.getconsulatntListattente(dataPyload).subscribe({
      next: (response: any) => {
        this.isLoadSpinner = false;

        console.log('response.data', response);
        if (response.data && response.data.data) {
          console.log('response.data', response.data);
          this.listconsulatant = response.data.data
          // .slice(0, this.endIndex);
          this.totalItems = response.data.total;
          this.spinner.hide();
          this.loadSpinnerTable = false;
          console.log('list  consultant client final', this.listconsulatant);
        }
      },
      error: (error: any) => {
        console.error('Error fetching list  consultant esn: ', error);
      },
    });
  }
  getconsultantByEmail(event: any) {
    const enteredEmail = event.target.value.trim();
    console.log('event', enteredEmail);
  
    if (enteredEmail === '') {
      this.enableFormFields();
      this.selectedconsultant = '';
      this.ConsultForm.patchValue({
        first_name: '',
        last_name: '',
        linkedin_link: '',
        cvName: '',
      });
      this.isexistemail = false;
      return;
    }
  
    this.esnconsultantservice.getconsultantexternebyemail(enteredEmail).subscribe({
      next: (res) => {
        if (res.status === 200) {
          console.log('reponse', res);
          this.selectedconsultant = res.data.cv;
          this.id = res.data.id;
          this.isexistemail = true;
          console.log('existe', this.isexistemail);
  
          this.ConsultForm.patchValue({
            email: res.data.email,
            first_name: res.data.first_name,
            last_name: res.data.last_name,
            linkedin_link: res.data.linkedin_link,
            emailProClient: res.data.emailProClient,
            selectedconsultant: res.data.cv,
          });
  
          if (res.data.cv) {
            this.file = { name: res.data.cv };
            console.log('file', this.file.name);
          }
  
          this.disableFormFields();
  
          if (res.data.linkedin_link != null) {
            this.ConsultForm.get('linkedin_link')?.disable();
          }
  
        
          if (enteredEmail !== res.data.email) {
            this.enableFormFields();
            this.ConsultForm.get('linkedin_link')?.enable();
            this.ConsultForm.patchValue({
              first_name: '',
              last_name: '',
              linkedin_link: '',
              emailProClient: '',
              selectedconsultant: '',
            });
            this.isexistemail = false;
          }
        } else
         {
          this.isexistemail = false;
          this.enableFormFields();
          this.ConsultForm.get('linkedin_link')?.enable();
          this.ConsultForm.patchValue({
            first_name: '',
            last_name: '',
            linkedin_link: '',
            emailProClient: '',
            selectedconsultant: '',
          });
        }
      },
      error: (error: any) => {
        console.log('error', error);
        console.log('message erreur ', error.error.message);
        this.isexistemail = false;
        this.selectedconsultant=''
        this.enableFormFields();
        this.ConsultForm.patchValue({
          first_name: '',
          last_name: '',
          linkedin_link: '',
          emailProClient: '',
          selectedconsultant: '',
        });
      },
    });
  }
  
  disableFormFields() {
    if (this.ConsultForm) {
      this.ConsultForm.get('first_name')?.disable();
      this.ConsultForm.get('last_name')?.disable();
      this.ConsultForm.get('linkedin_link')?.disable();
      this.ConsultForm.get('cv')?.disable();
    }
  }
  
  enableFormFields() {
    if (this.ConsultForm) {
      this.ConsultForm.get('first_name')?.enable();
      this.ConsultForm.get('last_name')?.enable();
      this.ConsultForm.get('emailProESN')?.enable();
      this.ConsultForm.get('linkedin_link')?.enable();
      this.ConsultForm.get('cv')?.enable();
    }
  }
  
  getSkills() {
    this.callofferService.getSkillsCompany().subscribe({
      next: (res) => {
        this.skills = res.data;
      },
      error: () => {},
    });
  }

  getListprojet() {
    this.idclientConnected =
      this.localStorageService.getData('clientConnected');

    this.callofferService.getProjectCompany(this.idclientConnected).subscribe({
      next: (response) => {
        this.listProjects = response.data;
      },
      error: (error) => {
        console.error('Error fetching projet: ', error);
      },
    });
  }

  /* unsubscribe from api */
  ngOnDestroy() {
    this.unsubscribeAll.next();

    this.unsubscribeAll.complete();
  }
  openModaladd(template: TemplateRef<any>, data?: any, mode?: string) {
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });
    console.log('data', data);
    this.isexistemail = false;
    this.selectedconsultant='';
   

    this.id = data.id;
    this.ConsultForm = this.createForm(data);
    this.ConsultForm.get('linkedin_link')?.enable();
    this.enableFormFields();
    this.ConsultForm.get('esn_id')?.setValue(data.ESN2);
    // const projectNames = data.project_names;
    // if (this.ConsultForm.value.project_ids !== null) {
    //   const selectedProjectIDs = this.listProjects
    //     .filter((project) => projectNames.includes(project.name))
    //     .map((project) => project.id);
    //   this.ConsultForm.get('project_ids')?.setValue(selectedProjectIDs);
    // } else {
    //   this.ConsultForm.get('project_ids')?.setValue('');
    // }
   
    // this.ConsultForm.get('tjm_achat')?.setValue(data.Tjm_achat);
    // this.ConsultForm.get('date_end_mission')?.setValue(data.Date_end_mission);
    // this.ConsultForm.get('date_first_mission')?.setValue(
    //   data.Date_first_mission
    // );
    // this.ConsultForm.get('number_days_of_service')?.setValue(
    //   data.Number_days_of_service
    // );
    // this.ConsultForm.get('date_first_service')?.setValue(
    //   data.Date_first_service
    // );
    // this.ConsultForm.get('user_id')?.setValue(data.id);
    // this.ConsultForm.get('consultnat_client_final_id')?.setValue(
    //   data.consultant_client_final_id
    // );

    console.log('updatte---', this.ConsultForm.value);
    this.enableFormFields();
  }
  openModal(template: TemplateRef<any>, data?: any, mode?: string) {
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });
    console.log('data', data);
    this.id = data.id;
    this.UpdateForm = this.updateForm(data);
    this.UpdateForm.get('linkedin_link')?.enable();
    this.enableFormFields();
    const projectNames = data.project_names;
    if (this.UpdateForm.value.project_ids !== null) {
      const selectedProjectIDs = this.listProjects
        .filter((project) => projectNames.includes(project.name))
        .map((project) => project.id);
      this.UpdateForm.get('project_ids')?.setValue(selectedProjectIDs);
    } 
    else {
      this.UpdateForm.get('project_ids')?.setValue([]);
    }

    this.UpdateForm.get('esn_id')?.setValue(data.ESN2);
    this.UpdateForm.get('tjm_achat')?.setValue(data.Tjm_achat);
    this.UpdateForm.get('date_end_mission')?.setValue(data.Date_end_mission);
    this.UpdateForm.get('date_first_mission')?.setValue(
      data.Date_first_mission
    );
    this.UpdateForm.get('number_days_of_service')?.setValue(
      data.Number_days_of_service
    );
    this.UpdateForm.get('date_first_service')?.setValue(
      data.Date_first_service
    );
    this.UpdateForm.get('user_id')?.setValue(data.id);
    this.UpdateForm.get('consultnat_client_final_id')?.setValue(
      data.consultant_client_final_id
    );
    console.log('update data form', this.UpdateForm.value);
  }

  updateconsultant() {
    console.log('idssssssss', this.UpdateForm.value.project_ids);

    if (this.UpdateForm.value.linkedin_link === null) {
      this.UpdateForm.get('linkedin_link')?.setValue('');
    }
    if (this.UpdateForm.value.cv === null) {
      this.UpdateForm.get('cv')?.setValue('');
    }
    if (this.UpdateForm.value.user_id === null) {
      delete this.UpdateForm.value.user_id;
    }
    if (this.UpdateForm.value.emailProClient === null) {
      // delete this.UpdateForm.value.emailProClient
      this.UpdateForm.get('emailProClient')?.setValue('');

    }
    this.idclientConnected =
      this.localStorageService.getData('clientConnected');
    this.UpdateForm.get('clientFinal_id')?.setValue(this.idclientConnected);
    this.UpdateForm.get('user_id')?.setValue(this.id);
    if (this.UpdateForm.value.ESN === null) {
      delete this.UpdateForm.value.ESN;
    }

    // if (this.UpdateForm.value.id) {
    //   delete this.UpdateForm.value.id;
    // }

    console.log('consultant externe', this.UpdateForm.value);
    this.companyService
      .updateconsultant(this.UpdateForm.value)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.toastrService.success(
            'consultant externe  a été modifié avec succès'
          );
          this.closeModal();
          this.getListconsultant();
        },
        error: (err) => {
          console.log('erreuemploy', err);
          this.spinner.hide();

          if (err?.error?.message) {
            if (
              err.error?.message?.emailProClient &&
              err.error?.message?.emailProClient[0] ===
                'The emailProClient has already been taken.'
            ) {
              this.toastrService.error(
                "L'adresse e-mail professionel a déjà été utilisée."
              );
            }
          }
        },
      });
  }

  dissocierconsultant(id: any) {
    console.log('idcandidate', id);
    console.log('idclient', this.idclientConnected);
    let formdata = new FormData();
    formdata.append('clientFinal_id', this.idclientConnected);
    formdata.append('candidate_id', id);
    console.log('formdata', formdata);
    Swal.fire({
      title: 'Voulez-vous vraiment dissocier ce consultant ? <br> La dissociation entraîne le verrouillage des CRA pour le mois en cours.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085D6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui, dissocier !',
      cancelButtonText: 'Annuler',
    }).then((result) => {
      if (result.isConfirmed) {
        this.companyService
          .dissocierconsultantclientfinal(formdata)
          .pipe(takeUntil(this.unsubscribeAll))
          .subscribe({
            next: (res: any) => {
              console.log('response', res);
              this.getListconsultant();
            },
            error: () => {
              this.spinner.hide();
            },
          });
      }
    });
  }
  Accepterconsultant(id: any) {
    console.log('idcandidate', id);
    console.log('idclient', this.idclientConnected);
    let formdata = new FormData();
    formdata.append('clientFinal_id', this.idclientConnected);
    formdata.append('candidate_id', id);
    console.log('formdata', formdata);
    Swal.fire({
      title: 'Voulez-vous vraiment Accepter ce consultant ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085D6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui, Accepter !',
      cancelButtonText: 'Annuler',
    }).then((result) => {
      if (result.isConfirmed) {
        this.companyService
          .AccepterConsultant(id,this.idclientConnected)
          .pipe(takeUntil(this.unsubscribeAll))
          .subscribe({
            next: (res: any) => {
              console.log('response', res);
              this.toastrService.success('consultant a été accepté ');
              this.searchconsultantexterne();
            },
            error: () => {
              this.spinner.hide();
            },
          });
      }
    });
  }
  Refuserconsultant(id: any) {
    console.log('idcandidate', id);
    console.log('idclient', this.idclientConnected);
    let formdata = new FormData();
    formdata.append('clientFinal_id', this.idclientConnected);
    formdata.append('candidate_id', id);
    console.log('formdata', formdata);
    Swal.fire({
      title: 'Voulez-vous vraiment Refuser ce consultant ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085D6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui, Refuser !',
      cancelButtonText: 'Annuler',
    }).then((result) => {
      if (result.isConfirmed) {
        this.companyService
          .RefuserConsultant(id,this.idclientConnected)
          .pipe(takeUntil(this.unsubscribeAll))
          .subscribe({
            next: (res: any) => {
              console.log('response', res);
              this.toastrService.success('consultant a été Refusé ');
              this.searchconsultantexterne();
            },
            error: () => {
              this.spinner.hide();
            },
          });
      }
    });
  }
}


